import { useTable as i } from "./useTable.js";
const S = ({
  columnApi: r,
  columnKey: s
}) => {
  const e = i(), t = e == null ? void 0 : e.getColumnByKey(s), n = (t == null ? void 0 : t.sort) ?? (t == null ? void 0 : t.sortFn);
  if (!t || !n || !(r != null && r.getCanSort())) return;
  const o = e.api.getState().sorting.find((g) => g.id === s), a = o != null && o.desc ? "descending" : "ascending";
  return {
    buttonProps: {
      label: t.sortableText,
      sort: o,
      toggleSorting: () => {
        r.toggleSorting();
      }
    },
    columnProps: {
      "aria-sort": o ? a : "none"
    }
  };
};
export {
  S as useIDSTableColumnSort
};
